module.exports = __webpack_public_path__ + "media/src/images/Sarah-Hood-p-500x501-09cb14f87b1c23c8165f67cfb47949ae.jpeg";